import React from 'react';
import {
  Dashboard as DashboardIcon,
  People as UsersIcon,
  Security as RoleIcon,
  Lock as PermissionsIcon,
  Assignment as RolePermissionsIcon,
  PersonAdd as UserPermissionsIcon,
  Receipt as TransactionsIcon,
  Webhook as WebhooksIcon,
  Receipt as InvoicesIcon,
  Business as MerchantIcon,
  AccountBalance as SettlementIcon,
} from '@mui/icons-material';
import type { MenuItem } from '@/components/layout';

// Helper function to create menu items safely
const createMenuItem = (
  id: string,
  text: string,
  iconComponent: React.ReactElement,
  path: string,
  options?: Partial<MenuItem>
): MenuItem => ({
  id,
  text,
  icon: iconComponent,
  path,
  ...options,
});

// Superadmin menu configuration
export const superadminMenuItems: MenuItem[] = [
  createMenuItem('dashboard', 'Dashboard', React.createElement(DashboardIcon), '/superadmin/dashboard'),
  createMenuItem('users', 'Users', React.createElement(UsersIcon), '/superadmin/users'),
  createMenuItem('roles', 'Roles', React.createElement(RoleIcon), '/superadmin/roles'),
  createMenuItem('permissions', 'Permissions', React.createElement(PermissionsIcon), '/superadmin/permissions'),
  createMenuItem('role-permissions', 'Role Permissions', React.createElement(RolePermissionsIcon), '/superadmin/role-permissions'),
  createMenuItem('user-permissions', 'User Permission', React.createElement(UserPermissionsIcon), '/superadmin/user-permissions'),
  createMenuItem('transactions', 'Transactions', React.createElement(TransactionsIcon), '/superadmin/transactions'),
  createMenuItem('webhooks', 'Webhooks', React.createElement(WebhooksIcon), '/superadmin/webhooks'),
  createMenuItem('settlement', 'Settlement', React.createElement(SettlementIcon), '/superadmin/settlement'),
  createMenuItem('merchants', 'Merchants', React.createElement(MerchantIcon), '/superadmin/merchant'),
  createMenuItem('invoice', 'Invoices', React.createElement(InvoicesIcon), '/superadmin/invoice'),
];

